import {
  FormLabel,
  Grid,
  gridRowSelectionManagerSelector,
  gridRowsLookupSelector,
  Paper,
  useGridApiContext,
  useGridSelector,
} from '@alice-financial/pretext-ui'
import * as React from 'react'
import { GrantAdminAccessButton } from './GrantAdminAccessButton'
import { EmployeeRow } from './types'

export const EmployeeListActions = () => {
  const apiRef = useGridApiContext()
  const selected = useGridSelector(apiRef, gridRowSelectionManagerSelector).data
  const rowsLookup = gridRowsLookupSelector(apiRef)
  const numSelected = selected.size
  const disabled = numSelected === 0
  const selectedRows = Array.from(selected).map((id) => rowsLookup[id]) as Array<EmployeeRow> // type coercion because inference is very complex here

  return (
    <Paper elevation={2} sx={{ padding: 2, paddingTop: 1.5 }}>
      <FormLabel disabled={disabled}>
        Update {numSelected || false} selected {numSelected === 1 ? 'employee' : 'employees'}
      </FormLabel>
      <Grid container columnGap={1}>
        <Grid>
          <GrantAdminAccessButton employees={selectedRows} />
        </Grid>
      </Grid>
    </Paper>
  )
}
